<template>
<div class="modalContents__object04" data-modalContents="signup02">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
                <h2 class="text-center">PLAN</h2>
                <form id='signup02_form' class="row no-gutters">
                    <!-- プラン内容-->
                    <h3 class="col-12">■ 動画視聴プラン内容</h3>
                    <div class="col-12 row no-gutters modalContents__object04--plan">
                        <div class="col-3 offset-2">
                            <h4 class="text-center">当日ライブ視聴</h4>
                        </div>
                        <div class="col-3">
                            <h4 class="text-center">アーカイブ視聴</h4>
                        </div>
                        <div class="col-4">
                            <h4 class="text-center">スペシャル特典</h4>
                        </div>
                    </div>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-2 text-center">
                            <div>ブロンズ</div>
                        </dt>
                        <dd class="col-3 text-center">
                            <div><em>60分まで</em></div>
                        </dd>
                        <dd class="col-3 text-center">
                            <div>×</div>
                        </dd>
                        <dd class="col-4 text-center">
                            <div>×</div>
                        </dd>
                        <dt class="col-2 text-center">
                            <div>シルバー</div>
                        </dt>
                        <dd class="col-3 text-center">
                            <div>無制限</div>
                        </dd>
                        <dd class="col-3 text-center">
                            <div>月5本まで</div>
                        </dd>
                        <dd class="col-4 text-center">
                            <div>×</div>
                        </dd>
                        <dt class="col-2 text-center">
                            <div>ゴールド</div>
                        </dt>
                        <dd class="col-3 text-center">
                            <div>無制限</div>
                        </dd>
                        <dd class="col-3 text-center">
                            <div>無制限</div>
                        </dd>
                        <dd class="col-4 text-center">
                            <div>×</div>
                        </dd>
                        <dt class="col-2 text-center">
                            <div>プラチナ<br>(サロン)</div>
                        </dt>
                        <dd class="col-3 text-center">
                            <div>無制限</div>
                        </dd>
                        <dd class="col-3 text-center">
                            <div>無制限</div>
                        </dd>
                        <dd class="col-4">
                            <div>● 抽選チケット<br>　 プレゼント<br>● サロン招待<br>● シンポジウム招待<br>● 著書プレゼント<br>　 等</div>
                        </dd>
                    </dl>
                    <p class="col-12 text-left">
                        <i>※ブロンズメンバープラン（無料会員）は、当日ライブの放送開始から前半60分のみの視聴が可能です。</i>
                    </p>
                    <!-- プラン選択-->
                    <h3 class="col-12">■ 動画視聴プラン選択</h3>
                    <div class="col-12 row no-gutters modalContents__object04--plan01">
                        <div class="col-md-1 col-2">
                            <input type="radio" name="plan" id="plan01" value="bronze" checked>
                            <label for="plan01" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="plan01">
                            <p class="col-8">ブロンズメンバー</p>
                            <em class="col-4">無料会員</em>
                        </label>
                    </div>
                    <div class="col-12 row no-gutters modalContents__object04--plan02">
                        <div class="col-md-1 col-2">
                            <input type="radio" name="plan" id="plan02" value="silver">
                            <label for="plan02" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="plan02">
                            <p class="col-8">シルバーメンバー</p>
                            <em class="col-4">月額 980円</em>
                        </label>
                    </div>
                    <div class="col-12 row no-gutters modalContents__object04--plan03">
                        <div class="col-md-1 col-2">
                            <input type="radio" name="plan" id="plan03" value="gold">
                            <label for="plan03" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="plan03">
                            <p class="col-8">ゴールドメンバー</p>
                            <em class="col-4">月額 3,980円</em>
                        </label>
                    </div>
                    <div class="col-12 row no-gutters modalContents__object04--plan04">
                        <div class="col-md-1 col-2">
                            <input type="radio" name="plan" id="plan04" value="platinum">
                            <label for="plan04" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="plan04">
                            <p class="col-8">プラチナメンバー（サロン）</p>
                            <em class="col-4">月額 9,800円</em>
                        </label>
                    </div>

                    <!-- メールマガジン-->
                    <h3 class="col-12">■ メールマガジン「ニッポンの問題点」</h3>
                    <div class="col-12 row no-gutters modalContents__object04--mm01">
                        <div class="col-md-1 col-2">
                            <input type="checkbox" name="mm01" id="mm01" value="1">
                            <label for="mm01" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="mm01">
                            <p class="col-8">「ニッポンの問題点」購読</p>
                            <em class="col-4">月額 500円</em>
                        </label>
                    </div>
                    <h3 class="col-12">■ メールマガジン「読むオプエド」</h3>
                    <div class="col-12 row no-gutters modalContents__object04--mm02">
                        <div class="col-md-1 col-2">
                            <input type="checkbox" name="mm02" id="mm02" value="1">
                            <label for="mm02" aria-hidden="true"></label>
                        </div>
                        <label class="col-md-11 col-10 row no-gutters" for="mm02">
                            <p class="col-8">「読むオプエド」購読</p>
                            <em class="col-4">月額 1,000円</em>
                        </label>
                    </div>
                    <p class="col-12 text-right">
                        <i>※表示価格は全て税別です。</i>
                    </p>
                    <!-- 戻るボタン-->
                    <div class="col-4 modalContents__object04--position01">
                        <button class="text-center btn modalContents__object04--back globalModal--btn" data-modal="signupBack01"
                            type="submit">戻る</button>
                    </div>
                    <!-- 次へボタン-->
                    <div class="col-6 offset-2">
                        <button id="signup02_btn" class="text-center btn globalModal--btn" data-modal="signupNext02"
                            type="submit">次へ</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  export default {
    name: 'SignupCregit',
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/signup_cregit.vue